import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const euApi = AiseaApiFactory.get("enterpriseUser");

export default {
  async fetchUser({ commit }, userId) {
    let res = await euApi.fetch(userId);
    commit("SET_USER", res.data);
  },
  async saveUser({ commit }, payload) {
    let res = await euApi.save(payload.userId, payload.data);
    if(!res.status) {
      throw res;
    }
    commit("SET_USER", res.data);
  },
};
